module.exports = __webpack_public_path__ + "static/media/method-3a-mob.3d03472f.png";